import Contact from "../components/sections/Contact";

export default function KontaktPage() {
  return <Contact />;
}
